import {
    CHART_DISPLAY_TYPE_ACCUMULATED_BAR,
    ImmutableVisConfig,
    ITEM_TYPE_CHART,
    VisConfig,
} from 'app/overview/dashboard/dashboard_item.service';
import Immutable from 'immutable';

function isImmutableVisConfig(
    config: ImmutableVisConfig | VisConfig,
): config is ImmutableVisConfig {
    return config instanceof Immutable.Map;
}

/**
 * Checks if the config is using accumulated data (non time series)
 * @param config supports both immutable vis configs and mutable vis configs
 */
export function isAccumulated(config: ImmutableVisConfig | VisConfig): boolean {
    if (isImmutableVisConfig(config)) {
        return (
            config.get('itemType') !== ITEM_TYPE_CHART ||
            config.get('chartDisplayType') === CHART_DISPLAY_TYPE_ACCUMULATED_BAR
        );
    } else {
        return (
            config.itemType !== ITEM_TYPE_CHART ||
            config.chartDisplayType === CHART_DISPLAY_TYPE_ACCUMULATED_BAR
        );
    }
}
